import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import { asDate } from '../utils/Date';

const sanitise = ({learnerId, moduleId, ...rest}) => ({
    userId: Number(learnerId),
    moduleId: Number(moduleId),
    ...rest,
    dateUpdated: asDate(rest.dateUpdated, null),
    dateExpires: asDate(rest.dateExpires),
});

const isFetching = ({isFetching = 0}, action) => {
    if (!action || !action.type) { return isFetching; }
    const parts = action.type.split('_');
    if (parts[0] !== 'REGISTRATION') { return isFetching; }
    switch (parts.pop()) {
        case 'REQUEST':
            return isFetching + 1;

        case 'SUCCESS':
        case 'FAILURE':
            return isFetching - 1;

        default:
            return isFetching;
    }
};

const getExcludeFilter = ({userId = null, moduleId = null}) => {
    return (r => !!r && r.userId !== userId && r.moduleId !== moduleId);
};

const registrations = ({registrations = []}, action) => {
    if (!action || !action.type) { return registrations; }
    switch (action.type) {
        case ActionTypes.REGISTRATION_LIST_REQUEST:
            return registrations;

        case ActionTypes.REGISTRATION_LIST_SUCCESS:
            return [
                ...registrations.filter(getExcludeFilter(action.payload)),
                ...action.data.map(sanitise)
            ];

        case ActionTypes.REGISTRATION_LIST_FAILURE:
            return registrations;

        default:
            return registrations;
    }
};

class RegistrationStore extends ReduceStore {

    getInitialState() {
        return {
            isFetching: 0,
            registrations: [],
        };
    }

    isFetching() {
        return this.getState().isFetching > 0;
    }

    getHistory({moduleId, userId, minDate = null}) {

        return this.getState().registrations.filter(r => !!r && r.moduleId === moduleId && r.userId === userId );
    }

    reduce(state, action) {
        return {
            isFetching: isFetching(state, action),
            registrations: registrations(state, action),
        }
    }
}

export default new RegistrationStore(Dispatcher);
